import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPathWithRef } from '../utils/attribution';
import './GettingStarted.css';

export const GETTING_STARTED_STORAGE_KEY = 'immigration_has_seen_getting_started';

/**
 * Post-signup orientation: who we are, what to expect, what's required, support.
 * Shown once after first signup; "Let's go!" continues to the app.
 */
export default function GettingStarted() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem('authToken')) {
      navigate(getPathWithRef('/'), { replace: true });
      return;
    }
  }, [navigate]);

  const handleLetsGo = (e) => {
    e.preventDefault();
    try {
      localStorage.setItem(GETTING_STARTED_STORAGE_KEY, 'true');
    } catch (err) {
      console.warn('Could not save getting started flag:', err);
    }
    navigate(getPathWithRef('/dashboard'), { replace: true });
  };

  return (
    <div className="mvp-getting-started-page">
      <div className="mvp-getting-started-card">
        <h1 className="mvp-getting-started-title">
          {t('gettingStarted.title', 'Getting started')}
        </h1>
        <section className="mvp-getting-started-section">
          <h2>{t('gettingStarted.whoWeAre', 'Who we are')}</h2>
          <p>{t('gettingStarted.whoWeAreContent', 'We are an immigration case management platform that combines AI guidance with professional review. Our virtual assistant is backed by real immigration expertise to help you through every step.')}</p>
        </section>
        <section className="mvp-getting-started-section">
          <h2>{t('gettingStarted.whatToExpect', 'What to expect')}</h2>
          <p>{t('gettingStarted.whatToExpectContent', 'You will answer questions and upload documents in a guided flow. We help collect the right information. Your case is then reviewed by our team before submission. You can track status and messages in one place.')}</p>
        </section>
        <section className="mvp-getting-started-section">
          <h2>{t('gettingStarted.whatIsRequired', 'What is required')}</h2>
          <p>{t('gettingStarted.whatIsRequiredContent', 'A valid passport, proof of address where applicable, and any documents specific to your pathway. We will tell you exactly what you need as you go.')}</p>
        </section>
        <section className="mvp-getting-started-section">
          <h2>{t('gettingStarted.support', 'Our support')}</h2>
          <p>{t('gettingStarted.supportContent', 'You can reach our specialists via in-app chat or phone. We support you in English and Spanish.')}</p>
        </section>
        <button type="button" className="mvp-getting-started-cta" onClick={handleLetsGo}>
          {t('gettingStarted.letsGo', "Let's go!")}
        </button>
      </div>
    </div>
  );
}
